/* import __COLOCATED_TEMPLATE__ from './experiences-badge.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import clsx from 'clsx';

const CLASS_NAME = 'GLM-c-seller-applications-experiences-badge';

class SellerApplicationsExperiencesBadge extends Component {
  @service session;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get experiencesText() {
    const { experiences } = this.args;

    return experiences.map(({ label }, index) => {
      // separate with 'and' when possible
      if (experiences.length === 1 || index === experiences.length - 2) {
        return label;
      } else if (index === experiences.length - 1) {
        return `and ${label}`;
      } else {
        return `${label},`;
      }
    }).join(' ');
  }
}

export default SellerApplicationsExperiencesBadge;
